var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('portal',{attrs:{"to":"app-header"}},[[_vm._v(" "+_vm._s(_vm.$t('checklistReport.title'))+" ")]],2),_c('v-fade-transition',{attrs:{"mode":"out-in"}},[_c('checklist')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }